module.exports = __webpack_public_path__ + "static/img/youshi2.f13fe629.png";